<!-- static content data from lang: past_script -->
<template>
    <div class="container">
        <div class="my-3" v-loading="loading">
            <b-card>
                <ValidationObserver ref="observer" v-slot="{ passes }">
                    <b-form @submit.stop.prevent="passes(filterData(true))">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 class="heading-title primary-text">{{lang.label.filter}}</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-8 input-section">
                                        <div class="row">
                                        
                                            <div class="col-md-3 col-xl-3 pr-md-0">
                                                <b-form-group>
                                                    <label class="label-control" for="name">
                                                        {{lang.label.patientName}}:
                                                        <!--<span class="text-danger">*</span>-->
                                                    </label>

                                                    <!--                                                    <ValidationProvider
                                                                                                            name="name of patient"
                                                                                                            rules="required"
                                                  v-slot="validationContext"
                                                                                                            > -->
                                                    <div>
                                                        <multiselect
                                                            v-model="models.patientName"
                                                            :options="patientNameList"
                                                            @input="onNameChange"
                                                            :preserve-search="false" 
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            label="name"
                                                            :custom-label="customLabel"
                                                            :placeholder="lang.label.selectName"
                                                            :taggable="true" 
                                                            @tag="addTag"
                                                            tag-placeholder="Search Patient"  
                                                            track-by="name"  
                                                            :preselect-first="true"
                                                            >
                                                                
                                                            <template slot="singleLabel" slot-scope="props">
                                                                <span class="option__title">{{ props.option.name }}</span>
                                                            </template>
                                                            <template slot="option" slot-scope="props" v-if="props.option.name && (props.option.email || props.option.mobile)">
                                                                <div class="option__desc"><span class="option__title">{{ props.option.name }}</span><br/><span class="option__small">{{ props.option.mobile }}</span><br/><span class="option__small">{{ props.option.email }}</span></div>
                                                            </template>
                                                        </multiselect>



                                                        <!-- <el-select v-model="models.patientName" filterable placeholder="Select">
                                                                <el-option
                                                                v-for="item in patientNameList"
                                                                :key="item.name"                                                                
                                                                :label="item.name"
                                                                :value="item.name">
                                                                <div class="el-select-template">
                                                                <h6 class="mb-0">{{ item.name }}</h6>
                                                                <p class="mb-0 el-select-text">{{ item.mobile }}</p>
                                                                <p class="mb-0 el-select-text"><small>{{ item.email }}</small></p>
                                                                </div>
                                                                </el-option> -->
                                                                  <!-- <template slot="singleLabel" slot-scope="props">
                                                                      <span class="option__title">{{ props.option.name }}</span>
                                                                      </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <span class="option__title">{{ props.option.name }}</span>
                                                                                <br/><span class="option__small">{{ props.option.mobile }}</span>
                                                                                <br/><span class="option__small">{{ props.option.email }}</span>
                                                                                </div>
                                                                        </template> -->
                                                        <!-- </el-select> -->
                                                    </div>
                                                </b-form-group>


                                            </div>
                                            <div class="col-md-3 col-xl-3 pr-md-0">
                                                <label class="label-control" for="idNumber">
                                                    Id Number of Patient:                                                            
                                                </label>
                                                <div>
                                                    <multiselect
                                                        v-model="models.idNumber"
                                                        :options="patientNameList"
                                                        @input="onIdChange"
                                                        :searchable="true"
                                                        :close-on-select="true"
                                                        :show-labels="false"
                                                        label="idNumber"
                                                        :custom-label="customLabel1"
                                                        placeholder="Select Patient Id" 
                                                        >
                                                            <template slot="singleLabel" slot-scope="props"><span class="option__title">{{ props.option.patientId }}</span></template>
                                                            <template slot="option" slot-scope="props">
                                                                <div class="option__desc"><span class="option__title">{{ props.option.patientId }}</span><br/><span class="option__small">{{ props.option.name }}</span></div>
                                                            </template>

                                                    </multiselect>
                                                </div>
                                            </div>
                                            <div class="col-md-9 col-xl-6 pr-md-0">
                                                <div class="row inputs">
                                                    <div class="col-md-3 col-xl-4">
                                                        <b-form-group>
                                                            <label class="label-control" for="from">{{lang.label.dateFrom}}:</label>
                                                            <el-date-picker
                                                                v-model="models.dateFrom"
                                                                type="date"
                                                                format="dd/MM/yyyy"
                                                                id="dateFrom"
                                                                :change="focus"
                                                                :picker-options="dateFromOptions"
                                                                :placeholder="lang.label.placeholder.date"
                                                                ></el-date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-3 col-xl-4">
                                                        <b-form-group>
                                                            <label class="label-control" for="to">{{lang.label.dateTo}}:</label>
                                                            <el-date-picker
                                                                v-model="models.dateTo"
                                                                type="date"
                                                                format="dd/MM/yyyy"
                                                                id="dateTo"
                                                                :picker-options="dateToOptions"
                                                                :placeholder="lang.label.placeholder.date"
                                                                ></el-date-picker>
                                                        </b-form-group>
                                                    </div>
                                                     <div class="col-md-3 col-xl-4">
                                                        <b-form-group>
                                                            <label class="label-control" for="to">{{lang.label.dob}}:</label>
                                                            <el-date-picker
                                                                v-model="models.dob"
                                                                type="date"
                                                                format="dd/MM/yyyy"
                                                                   :picker-options="dateToOptions"
                                                                :placeholder="lang.label.placeholder.date"
                                                                id="dob"
                                                                ></el-date-picker>
                                                        </b-form-group>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-6">
                                                <b-form-group>
                                                    <label class="label-control" for="status">{{lang.label.status}}:</label>
                                                    <b-form-checkbox-group
                                                        v-model="models.status"
                                                        :options="status"
                                                        text-field="name"
                                                        value-field="item"
                                                        class="mt-3 pt-1"
                                                        ></b-form-checkbox-group>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-4 button-section pl-lg-0 align-self-center">
                                                <b-form-group class="mb-0">
                                                    <b-btn type="submit" variant="secondary" class="mr-2"  >{{lang.label.buttons.filter}}</b-btn>

                                                    <b-btn type="button" variant="secondary" @click="resetData()">{{lang.label.buttons.reset}}</b-btn>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </b-form>
                </ValidationObserver>
                <hr class="mx--body my-0" />
                <div class="row">
                    <template v-if="errored"> {{lang.label.error}}</template>
                    <template v-else>
                        <template v-if="data.length > 0">
                            <div class="col-md-6 col-lg-4" v-for="(past, index) in data" :key="index">
                                <b-card class="shadow-none ps-scr-dtl" body-class="p-3" @click="detailsClick(past.id,past.appointmentId)">
                                    <div class="past-details">
                                        <div class="row">
                                            <div class="col-12">
                                                <h4 class="name">{{(past.patientName !=''? past.patientName : lang.label.nodata) }}</h4>
                                            </div>
                                            <div class="col-12 ">
                                                <span class="my-1 d-block">{{lang.label.receivedDate}}: {{(past.receivedDate!=''? formatedate(past.receivedDate) : lang.label.nodata)}}</span>

                                            </div>
                                            
                                            <div class="col-12">
                                                <span class="my-1 d-block">{{lang.label.scriptId}}: {{(past.scriptNo!=''? past.scriptNo : lang.label.nodata)}}</span>

                                            </div>
                                            <div class="col-12">
                                                <span class="my-1 d-block">{{lang.label.sentDate}}: {{(past.scriptCreatedAt !='' ? formatedate(past.scriptCreatedAt) : lang.label.nodata)}}</span>
                                            </div>
                                            
<!--                                            <div class="col-12 ">
                                                <span class="my-1 d-block">{{lang.label.sentDate}}: {{(past.scriptCreatedAt!=''? formatedate(past.scriptCreatedAt) : lang.label.nodata)}}</span>

                                            </div>-->
<!--                                            <div class="col-12">
                                                <span class="my-1 d-block">{{lang.label.scriptRequestStatus}}: {{(past.scriptStatus!=''? past.scriptStatus : lang.label.nodata)}}</span>

                                            </div>-->
                                            <div class="col-12  text-right">
                                                <span class="my-1 d-block">{{lang.label.status}}: {{(past.status!=''? past.status : lang.label.nodata)}}</span>

                                            </div>
                                <div class="col-12" >
                                            <span v-if="past.scriptStatus=='Rejected'" style="color: red">{{lang.label.rejected}}</span>

                                        </div>

                                        </div>
                                    </div>
                                </b-card>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 text-center pt-3">{{lang.label.noDataFound}}</div>
                        </template>
                    </template>
                </div>
            </b-card>
        </div>
        <div v-observe-visibility="visibilityChanged">
        </div>
    </div>
</template>

<script>
    import jsondata from "../assets/json/data.json";
    import Multiselect from 'vue-multiselect';
    var moment = require('moment');
    import {mapGetters} from "vuex";
    import Vue from "vue";
    import VueObserveVisibility from 'vue-observe-visibility'
    Vue.use(VueObserveVisibility)
    

    export default {
        components: {
            Multiselect
        },
        computed: {
            ...mapGetters({
                    login: "login",
                    loading: "loading",
                    patientInfo:"patientInfo",
                    fromGroupRequests:"fromGroupRequests"
            }),
            dateFrom() {
                return this.models.dateFrom;
            },
            dateTo() {
                return this.models.dateTo;
            }
        },

        data() {
            return {
                data: [],
                lang: this.$lang.past_script,
                selectedPatient: null,
                patientNameList: [],
                errored: false,
                models: {
                    patientName: '',
                    dateFrom: '',
                    dateTo: '',
                    status: [],
                    idNumber:'',
                    dob:''
                },
                status: [
                    {item: "1", name: "Paid"},
                    {item: "0", name: "Unpaid"}
                ],
                disablingFromDate: '',
                disablingToDate: '',
                dateFromOptions: {
                    disabledDate: this.disableFromDate
                },
                dateToOptions: {
                    disabledDate: this.disableToDate
                },
                appointmentsList: [],
                currentPageFilNull: 1,
                currentPageFil: 1,
                currentPageFil2:1,
                filtered: false,
                allLoaded:false,
                allLoadedFil: false,
                checkedData:false
            };
        },

        created() {
            this.$store.dispatch('getPatientDetails').then(response => {
                //this.patientNameList: = response.data;
                if (response.data) {
                    response.data.forEach((object, index) => {
                        if (object.name) {
                            this.patientNameList.push({id: object.id, name: object.name, mobile: object.mobile, patientId: object.idNumber,email:object.email});
                        }
                    });
                }

            });
//            this.appointmentList();
        },
        mounted() {   
            // console.log(this.$route)
             if(this.fromGroupRequests==false){
                this.getApiData();
             }
            this.setPatientData();
            // window.addEventListener('scroll', this.scroll, false);
        },
        methods: {
            nameChange(q){
                    console.log(q)
            },
            addTag(query){
                    this.models.idNumber='';
                    // console.log("query",query);
                    this.patientNameList.push({"name":query,"email":"","mobile":""});
                    // console.log(this.patientNameList)

                    let last_elem=this.patientNameList[this.patientNameList.length-1];   // storing last elem of ana array
                    // console.log(last_elem)
                    this.models.patientName=last_elem;
                    // console.log(this.models.patientName.name);  
                    // this.getApiData(1,true,this.models.patientName.name);
            },
            onNameChange() {
                this.models.idNumber = this.models.patientName;
                this.models.dob='';
            },
            onIdChange() {
                this.models.patientName = this.models.idNumber;
                                this.models.dob='';

            },
            visibilityChanged(){
                if(this.fromGroupRequests){
                    this.setPatientData();
                }else{
                    if (this.filtered) {
                        if(!this.allLoadedFil){
                            this.getApiData(1);
                        }
                    } else {
                            // !this.loading reduces additional api data while scrolling
                            if (!this.allLoaded && !this.loading) {
                                this.getApiData();
                            }
                    }
                }
            },
            scroll () {
                window.onscroll = () => {
                    let bottomOfWindow = document.documentElement.scrollHeight - document.documentElement.scrollTop === document.documentElement.clientHeight;
                    if (bottomOfWindow) {
                        //  this.scrolledToBottom = true // replace it with your code
                        // console.log('Page End');
                        if (this.filtered) {
                            this.getApiData(1);
                        } else {
                            this.getApiData();
                        }
                    }
                }
            },
            setPatientData(){
                var self=this;
                    if(self.fromGroupRequests){
                        self.models.patientName=self.patientInfo.patientName;
                        self.models.dob=self.patientInfo.dob;
                        self.models.patientId='0';
                        self.models.idNumber=self.patientInfo.idNumber;
                        self.models.dob=self.patientInfo.dob;

                        //  this.models.patientName= this.patientInfo.patientId;
                        // this.models.patientName.id
                        self.models.patientName= { "id": '0', "name": self.patientInfo.patientName, "mobile": self.patientInfo.mobile };
                        if(self.checkedData==false){
                            self.checkedData=true;
                                self.getApiData(1,true);
                        }
                    }else{
                        this.models.patientName="";
                        this.models.dob="";
                        this.models.patientId="";
                        this.models.idNumber="";
                        // this.models.patientName= { "id": this.patientInfo.patientId, "name": this.patientInfo.patientName, "mobile": this.patientInfo.mobile };
                    }  
            },
            appointmentList() {
                this.$store.dispatch('appointmentList', {status: 0})
                        .then(response => {
                            this.appointmentsList = response.data;
                            // console.log('app', this.appointmentsList);
                            // this.data = [{"patientId":602,"name":"Chirag Patient","email":"patient@mailinator.com","mobile":"0989898989","gender":"","bloodGroup":"","dob":"","address":"","pharmacistId":593,"pharmacistName":"pharmacy name","pharmacistEmail":"pharmact@mailinator.com","pharmacistMobile":"0999999999","appointmentId":22,"idNumber":"7545SA","isMinor":1,"parentName":"Guard A","idNumberParent":"ADE564","medicine":"benadon 10","specialInstructions":"No special"},{"patientId":601,"name":"north Guwahati","email":"admin@pragati.com","mobile":"0987987987","gender":"","bloodGroup":"","dob":"","address":"","pharmacistId":593,"pharmacistName":"pharmacy name","pharmacistEmail":"0999999999","pharmacistMobile":"pharmact@mailinator.com","appointmentId":23,"idNumber":"7545WESA","isMinor":1,"parentName":"Guard AA","idNumberParent":"ADES3564","medicine":"benadon 100","specialInstructions":"No special"}]
                        })
                        .catch(error => {
                            this.errored = true;
                        })
                        .finally(() => this.loading = false)
            },
            scriptDetails() {
                let subject = 'mailto:' + this.login.email + '?subject=Pay Script::Script Generated&body=';
                let body = this.models.patientName + ', you submitted a request for a script / form to ' + this.login.name + '. If you requested the document, please click this link ' + '"' + this.sharedUrl + '"' + ' to make payment and download the document. Thank you, ' + this.login.name;
                return subject + body;
            },
            formatedate(date) {
                return moment(date,'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
            },
            detailsClick(id, appointmentId) {
                if (id > 0) {
                    this.$router.push({name: 'past-script-details', params: {id: id}})
                } else {
                    if (appointmentId != '') {
                        this.$router.push({name: 'past-script-appointment-details', params: {id: appointmentId}})
                    }
                }
            },
            filterData(flag) {
                this.$store.commit('setLoading', true);
                this.allLoadedFil = false;
                if (flag) {
                this.getApiData(1, true);
                this.filtered = true;
                } else {
                    this.getApiData(1);
                }
            },
            resetData() {
                this.$store.commit('setLoading', true);
                this.$store.commit('setFromGroupRequests', false);
                this.models.status = [];
                this.models.patientName = null;
                this.models.dateFrom = '';
                this.models.dateTo = '';
                this.models.dob='';
                this.models.patientId='';
                this.models.idNumber='';
                this.currentPageFilNull=1;
                this.currentPageFil2=1;
                this.getApiData(0,false,'',true);
                this.$nextTick(() => {
                    this.$refs.observer.reset();
                });
            },
            getApiData(applyFilter = 0, flag,uname,refreshFlag=false) {
                this.$store.commit('setLoading', true);
                let apiName=this.$route.params.flag==true?'getAllPastScriptList':'getPastScriptList'
                let data = {};
                if (applyFilter == 0) {
                    if(refreshFlag){
                        this.data=[];
                    }
                    data = {
                        "status": "",
                        "patientId": 0,
                        "fromDate": "",
                        "toDate": "",
                        "idNumber":"",
                        "pageNo": this.currentPageFilNull
                    };
                    this.currentPageFilNull = this.currentPageFilNull + 1;
                }else if(applyFilter==1 && uname){
                    this.data=[];
                    this.currentPageFil2=1;
                    
                    data={
                        "patientName":uname,
                        "pageNo": this.currentPageFil2,
                        "patientId":"",
                        "idNumber":""
                    };
                    this.currentPageFil2+=1;

                } else {

                    var statusdata = this.models.status;
                    var status = '';
                    if (statusdata.length === 1)
                    {
                        status = this.models.status[0];
                    }
                    if (flag) {
                        this.data = [];
                        this.currentPageFil = 1;
                    }
                    data = {
                        "status": status,
                        "patientId": (this.models.patientName != null) ? this.models.patientName.id : 0,
                        "fromDate": (this.models.dateFrom != null && this.models.dateFrom != "") ? moment(this.models.dateFrom).format("YYYY-MM-DD") : "",
                        "toDate": (this.models.dateTo != null && this.models.dateTo != "") ? moment(this.models.dateTo).format("YYYY-MM-DD") : "",
                        "idNumber":(this.models.idNumber != null) ? this.models.idNumber.patientId : "",
                        "pageNo": this.currentPageFil,
                        "patientName":(this.models.patientName != null) ? this.models.patientName.name : "",
                        "birthDate":(this.models.dob!=null && this.models.dob!="")? moment(this.models.dob).format("YYYY-MM-DD"):"",

                   };
                   this.currentPageFil = this.currentPageFil + 1;
                }
                this.$store.dispatch(apiName, data)
                        .then( response => {
                            if (response.data.length > 0) {
                                this.data = this.data.concat(response.data);
                            } else if (data['patientId'] == '') {
                                this.allLoaded = true;
                                this.allLoadedFil = false;
                            } else {
                                this.allLoaded = false;
                                this.allLoadedFil = true;
                            }
                            this.$store.commit('setLoading', false);
                        })
                        .catch(error => {
                            this.errored = true;
                        })
                        .finally(() => this.$store.commit('setLoading', false))
            },
            disableFromDate(date) {
                if (this.models.dateTo != null && this.models.dateTo != '') {
                    return (date > Date.now() || date > this.models.dateTo);
                } else {
                    return (date > Date.now());
                }
            },
            disableToDate(date) {

                return (date < this.models.dateFrom || date > Date.now());
            },
            focus() {
                // alert()
            },
            customLabel( { name, mobile,email }) {
                return `${name} ${mobile} ${email}`;
            },
            customLabel1( { patientId, name }) {
                return `${patientId} ${name}`;
            }
        },
        watch: {
            dateFrom() {
                this.disablingToDate = this.models.dateTo;
            },
            dateTo() {
                this.disablingFromDate = this.models.dateFrom;
            },
            'models.patientName'() {
                this.$emit('change', this.models.patientName);
            }
        },
    };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>







